module.exports = {
  "id": "left-right",
  "color": "green",
  "title": "left-right",
  "icon": "horizontalarrows",
  "description": "Make a piece go left and right.",
  "category": "movement",
  "exposedVariables": [
    {
      "variableName": "left-right distance",
      "spriteName": "$glitch_target",
      "tooltip":"Set the distance the piece will move",
      "input": {
        "type": "slider",
        "max": 360,
        "value": 60,
        "step": 1,
        "min": "0"
      },
      "value": "80"
    },
    {
      "variableName": "left-right speed",
      "spriteName": "$glitch_target",
      "tooltip":"Set the speed the piece will move",
      "input": {
        "type": "slider",
        "max": 20,
        "value": 5,
        "min": "0",
        "step": ".1"
      },
      "value": "2"
    },
    {
      "variableName": "left-right pause",
      "spriteName": "$glitch_target",
      "tooltip":"Set the amount of time the piece will pause before going back in the other direction",
      "input": {
        "type": "slider",
        "max": 5,
        "value": 1,
        "min": "0",
        "step": ".1"
      },
      "value": ".5"
    }
  ],
  "info": [
    {
      "text": "Make a piece move left and right forever",
      "image": "provision/glitches/left-right/left-right.gif"
    }
  ],
  "codeImage": "provision/glitches/left-right/left-right.png",
  "code": null,
  "zip": null,
  "sb3": null
}
;